import PropTypes from "prop-types"
import styled from "styled-components"
import MentorGroupList from "./MentorGroupList"

const Container = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 800px;
  min-width: 100%;
  min-height: 100px;
`

const MentorGroups = ({ parentId = null }) => {
  return (
    <Container>
      <MentorGroupList parentId={parentId} />
    </Container>
  )
}

MentorGroups.displayName = "MentorGroups"

MentorGroups.propTypes = {
  parentId: PropTypes.number
}

export default MentorGroups
